(function () {
  'use strict';

  if (window.__zone2JudgeMeStyling) return;
  window.__zone2JudgeMeStyling = true;

  var root = null;
  var widgetObserver = null;
  var discoveryObserver = null;
  var frame = 0;

  function update() {
    frame = 0;

    if (!root || !root.isConnected) return;

    root.querySelectorAll('.jdgm-rev-widg').forEach(function (widget) {
      var stars = widget.querySelector('.jdgm-rev-widg__summary-stars');
      var rating = parseFloat(widget.getAttribute('data-average-rating'));

      if (stars && Number.isFinite(rating) && rating >= 0 && rating <= 5) {
        var average = stars.querySelector('.z2-jdgm-average');

        if (!average) {
        average = document.createElement('span');
        average.className = 'jdgm-rev-widg__summary-average z2-jdgm-average';
        average.setAttribute('aria-hidden', 'true');
        stars.appendChild(average);
        }

        // Bijvoorbeeld 4.61 → 4.6.
        // De echte score komt altijd uit Judge.me.
        var text = rating.toFixed(1);

        if (average.textContent !== text) {
          average.textContent = text;
        }
      }
    });

    root.querySelectorAll('a.jdgm-write-rev-link').forEach(function (button) {
      if (!button.classList.contains('btn')) {
        button.classList.add('btn');
      }

      if (!button.classList.contains('btn-theme')) {
        button.classList.add('btn-theme');
      }
    });
  }

  function scheduleUpdate() {
    if (!frame) {
      frame = window.requestAnimationFrame(update);
    }
  }

  function connect() {
    var nextRoot = document.getElementById('judgeme_product_reviews');

    if (!nextRoot) {
      if (widgetObserver) {
        widgetObserver.disconnect();
      }

      root = null;

      if (!discoveryObserver) {
        // Wacht totdat Judge.me in de pagina staat.
        discoveryObserver = new MutationObserver(connect);

        discoveryObserver.observe(document.documentElement, {
          childList: true,
          subtree: true
        });
      }

      return;
    }

    if (discoveryObserver) {
      discoveryObserver.disconnect();
      discoveryObserver = null;
    }

    if (root !== nextRoot) {
      if (widgetObserver) {
        widgetObserver.disconnect();
      }

      root = nextRoot;

      // Pas de styling opnieuw toe wanneer Judge.me inhoud bijwerkt.
      widgetObserver = new MutationObserver(scheduleUpdate);

      widgetObserver.observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['data-average-rating']
      });
    }

    scheduleUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connect, {
      once: true
    });
  } else {
    connect();
  }

  document.addEventListener('shopify:section:load', connect);
})();

/* Geen automatische titel-focus bij het openen van het formulier */
(function () {
  'use strict';

  if (window.__z2JdgmNoTitleAutofocus) return;
  window.__z2JdgmNoTitleAutofocus = true;

  function install() {
    var jdgm = window.jdgm;

    if (!jdgm || typeof jdgm.openForm !== 'function') return;
    if (jdgm.openForm.__z2NoTitleAutofocus) return;

    var originalOpenForm = jdgm.openForm;

    function openWithoutTitleFocus($widget) {
      var widget = $widget && $widget[0];

      var field = widget &&
        widget.closest('#judgeme_product_reviews') &&
        widget.querySelector(
          '.jdgm-form-wrapper input[name="review_title"]'
        );

      if (!field) {
        return originalOpenForm.apply(this, arguments);
      }

      var ownFocus = Object.getOwnPropertyDescriptor(field, 'focus');

      if (ownFocus && !ownFocus.configurable) {
        return originalOpenForm.apply(this, arguments);
      }

      // Alleen tijdens het openen wordt de automatische focus overgeslagen.
      Object.defineProperty(field, 'focus', {
        configurable: true,
        writable: true,
        value: function () {}
      });

      try {
        return originalOpenForm.apply(this, arguments);
      } finally {
        // Direct herstellen, zodat normaal invullen mogelijk blijft.
        if (ownFocus) {
          Object.defineProperty(field, 'focus', ownFocus);
        } else {
          delete field.focus;
        }
      }
    }

    openWithoutTitleFocus.__z2NoTitleAutofocus = true;
    jdgm.openForm = openWithoutTitleFocus;
  }

  install();

  // Ook toepassen wanneer Judge.me het formulier later laadt.
  document.addEventListener('jdgm.doneSetupReviewForm', install);
  document.addEventListener('shopify:section:load', install);

  // Uitvoeren vóór Judge.me de klik op de schrijfknop verwerkt.
  document.addEventListener('click', function (event) {
    var target = event.target;

    if (
      target &&
      target.closest &&
      target.closest('#judgeme_product_reviews .jdgm-write-rev-link')
    ) {
      install();
    }
  }, true);
})();

(function () {
  'use strict';

  if (window.__z2JdgmSubmitTheme) return;
  window.__z2JdgmSubmitTheme = true;

  function enhanceSubmitButtons() {
    document.querySelectorAll(
      '#judgeme_product_reviews .jdgm-form__fieldset-actions > input.jdgm-submit-rev'
    ).forEach(function (input) {
      var wrapper = document.createElement('span');

      wrapper.className = 'btn btn-theme z2-jdgm-submit-wrap';

      input.before(wrapper);
      wrapper.appendChild(input);

      // Houd eventuele foutmeldingen buiten de knop.
      new MutationObserver(function () {
        wrapper.querySelectorAll('.jdgm-form__submit-error').forEach(function (error) {
          var active = document.activeElement;
          var restoreFocus = active && error.contains(active);

          wrapper.before(error);

          if (restoreFocus) {
            active.focus({ preventScroll: true });
          }
        });
      }).observe(wrapper, { childList: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceSubmitButtons, {
      once: true
    });
  } else {
    enhanceSubmitButtons();
  }

  document.addEventListener('jdgm.doneSetupReviewForm', enhanceSubmitButtons);
  document.addEventListener('shopify:section:load', enhanceSubmitButtons);
})();